import { faDropbox } from '@fortawesome/free-brands-svg-icons/faDropbox';
import { faEvernote } from '@fortawesome/free-brands-svg-icons/faEvernote';
import { faGoogleDrive } from '@fortawesome/free-brands-svg-icons/faGoogleDrive';
import { faMicrosoft } from '@fortawesome/free-brands-svg-icons/faMicrosoft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	AlertBanner,
	Button,
	Card,
	CardLayoutType,
	Colour,
	ColourStateSolid,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormatLocaleDate } from '@ukpostbox/helpers';
import React, { useEffect } from 'react';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function AppIntegrations() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	useEffect(() => {
		updatePageMeta({
			title: t('settings.appIntegrations.title'),
		});
	}, [currentLocale]);

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>{t('settings.appIntegrations.title')}</h2>
			</StackHorizontal>

			<StackVertical gap={FlexGap.ExtraLarge}>
				<AlertBanner
					title='Dropbox Integration Requires Attention'
					content={
						"Dropbox have updated the way we connect to to your Dropbox account. To continue using the Dropbox integration, you need to reconnect your Dropbox account. Please click the 'Reconnect' button below to proceed.\n"
					}
					colour={Colour.Warning}
				/>

				<div>
					<h6 className='sub-heading mb-xs alert-text'>{t('status.expired')}</h6>
					<div className='card'>
						<StackHorizontal gap={FlexGap.Small} extraClass='p-md' align={FlexAlign.Center}>
							<div>
								<FontAwesomeIcon icon={faDropbox} size='2x' />
							</div>
							<div className='flex-column'>
								<h6 className='m-0'>Dropbox</h6>
								<div className='fade'>
									{t('settings.appIntegrations.labels.expiredDate', {
										date: FormatLocaleDate(new Date(), currentLocale),
									})}
								</div>
							</div>
							<div className='ml-a'>
								<Button title='Reconnect' squared colour={ColourStateSolid.Success} />
							</div>
						</StackHorizontal>
					</div>
				</div>

				<div>
					<Card
						header={{
							title: t('status.active'),
						}}
						type={CardLayoutType.SlimHeader}
						emptyBody
					>
						<StackHorizontal gap={FlexGap.Small} extraClass='p-md' align={FlexAlign.Center}>
							<div>
								<FontAwesomeIcon icon={faEvernote} size='2x' />
							</div>
							<div className='flex-column'>
								<h6 className='m-0'>Evernote</h6>
								<div className='fade'>
									{t('settings.appIntegrations.labels.activatedDate', {
										date: FormatLocaleDate(new Date(), currentLocale),
									})}
								</div>
							</div>
							<div className='ml-a'>
								<Button title='Disconnect' squared />
							</div>
						</StackHorizontal>
					</Card>
				</div>

				<div>
					<Card
						header={{
							title: t('status.inActive'),
						}}
						type={CardLayoutType.SlimHeader}
						emptyBody
					>
						<StackHorizontal gap={FlexGap.Small} extraClass='p-md' align={FlexAlign.Center}>
							<div>
								<FontAwesomeIcon icon={faMicrosoft} size='2x' />
							</div>
							<div>
								<h6 className='m-0'>One Drive</h6>
							</div>
							<div className='ml-a'>
								<Button title='Connect' squared />
							</div>
						</StackHorizontal>
						<StackHorizontal gap={FlexGap.Small} extraClass='p-md' align={FlexAlign.Center}>
							<div>
								<FontAwesomeIcon icon={faGoogleDrive} size='2x' />
							</div>
							<div>
								<h6 className='m-0'>Google Drive</h6>
							</div>
							<div className='ml-a'>
								<Button title='Connect' squared />
							</div>
						</StackHorizontal>
					</Card>
				</div>
			</StackVertical>
		</>
	);
}

export default AppIntegrations;
